// Функція, яка перевіряє — ми у PWA чи в браузері
function isInStandaloneMode() {
  // iOS: special media query
  const iosStandalone = window.matchMedia('(display-mode: standalone)').matches;
  // Android / десктоп: navigator.standalone (тільки Safari)
  const safariStandalone = window.navigator.standalone === true;
  return iosStandalone || safariStandalone;
}

// Відстежуємо подію "beforeinstallprompt"
// Це коли браузер дозволяє показати попап "Встановити додаток"
window.addEventListener('beforeinstallprompt', (event) => {
  event.preventDefault(); // блокуємо дефолтний попап
  const deferredPrompt = event;

  if (!isInStandaloneMode()) {
    // Якщо НЕ у PWA → показуємо свою інструкцію
    const btn = document.createElement("button");
    btn.textContent = "📲 Встановити додаток";
    btn.style.position = "fixed";
    btn.style.bottom = "20px";
    btn.style.right = "20px";
    btn.style.padding = "10px 15px";
    btn.style.background = "#0a84ff";
    btn.style.color = "#fff";
    btn.style.border = "none";
    btn.style.borderRadius = "8px";
    btn.style.cursor = "pointer";
    document.body.appendChild(btn);

    
    // Якщо юзер натискає → викликаємо системне вікно встановлення
    btn.addEventListener("click", () => {
      deferredPrompt.prompt(); // показуємо системний діалог
      deferredPrompt.userChoice.then(choice => {
        if (choice.outcome === "accepted") {
          console.log("✅ Користувач встановив додаток");
        } else {
          console.log("❌ Користувач відхилив встановлення");
        }
      });
    });
  }
});

// Якщо ми вже в PWA → нічого не показуємо
if (isInStandaloneMode()) {
  console.log("🚀 Додаток запущений як PWA");
} else {
  console.log("🌐 Додаток запущений у браузері");
}

import home from "./img/Home.svg";
import homeBlack from "./img/HomeBlack.svg";
import raiting from "./img/Raiting.svg";
import raitingBlack from "./img/RaitingBlack.svg";
import calendar from "./img/Calendar.svg";
import calendarBlack from "./img/CalendarBlack.svg";
import folder from "./img/Folder.svg";
import folderBlack from "./img/FolderBlack.svg";

const backButton = document.querySelector(".backButton");
const defaultActive = "home";


const iconsMap = {
  home: {
    default: homeBlack,
    active: home,
    offset: "0"
  },
  raiting: {
    default: raitingBlack,
    active: raiting,
    offset: "24"
  },
  calendar: {
    default: calendarBlack,
    active: calendar,
    offset: "48"
  },
  folder: {
    default: folderBlack,
    active: folder,
    offset: "72"
  }
};

const contentImages = document.querySelectorAll(".content img");
const icons = document.querySelectorAll(".ico");

icons.forEach((icon, index) => {
  const name = icon.dataset.name;

  // 👉 якщо це home — активна
  if (name === defaultActive) {
    icon.src = iconsMap[name].active;
    backButton.style.left = iconsMap[name].offset;
  } else {
    icon.src = iconsMap[name].default;
  }

  icon.addEventListener("click", () => {
    icons.forEach(i => {
      const n = i.dataset.name;
      i.src = iconsMap[n].default;
    });

    icon.src = iconsMap[name].active;
    backButton.style.left = iconsMap[name].offset + "%";

    contentImages.forEach(img =>
      img.classList.remove("contentActive")
    );

    contentImages[index].classList.add("contentActive");
  });
});




// const backButton = document.querySelector(".backButton");
// const icons = document.querySelectorAll(".ico");
// const navImg = document.querySelector(".navImg");

// icons.forEach(icon => {
//   icon.addEventListener("click", () => {

//     // reset
//     icons.forEach(i => {
//       i.src = i.dataset.default;
//     });

//     // active
//     icon.src = icon.dataset.active;

//     console.log(navImg.offsetWidth);


//     // indicator
//     backButton.style.left = icon.dataset.offset + "%";
//   });
// });
